<header
  class="flex flex-row items-center border-b bg-gray-50 p-2 pb-2 justify-between min-h-[58px]align-middle min-h-12 text-sm"
>
  <nav class="border-gray-200 w-full">
    <div class="flex flex-wrap items-center justify-between mr-2">
      @if(searchEnabled()){
        <div  class="mr-2 w-1/3">
          <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <img
                src="../../../../../assets/dashboard-header-svg/search.svg"
                alt="Search Icon"
                class="w-4 h-4 text-gray-500"
              />
            </div>
            <input
              type="search"
              id="default-search"
              class="w-full text-sm pl-8 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-transparent focus:border-primary"
              placeholder=""
              (input)="onSearchChange($event)"
              required
            />
          </div>
        </div>
      }
      <a
        routerLink="/booking"
        title="Book a Project"
        class="flex items-center md:ml-auto px-2 h-max font-medium text-primary hover:bg-accent-blue hover:text-primary"
      >
        <img
          src="../../../../../assets/dashboard-header-svg/add.svg"
          alt="Book Icon"
          class="fill-primary text-white m-1"
        />
        Book a Project</a
      >
      <div class="flex justify-end">
        <button
          data-collapse-toggle="navbar-sticky"
          type="button"
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="navbar-sticky"
          aria-expanded="false"
        >
          <img src="../../../../../assets/dashboard-header-svg/menu.svg" alt="Menu Icon" />
        </button>
      </div>
      <div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
        <ul
          class="flex flex-col flex-end ml-auto w-max p-4 md:p-0 mt-4 font-medium md:flex-row md:mt-0 md:border-0"
        >
          <li>
            <a routerLink="/profile/dashboard" title="Dashboard" class="px-2 h-max hover:bg-accent-blue flex items-center">
              <img src="../../../../../assets/dashboard-header-svg/home.svg" alt="Home Icon" class="m-1" />
              <span class="sm:flex md:hidden xl:flex">Dashboard</span></a
            >
          </li>
          <li>
            <a routerLink="/templates/index" title="Templates" class="px-2 h-max hover:bg-accent-blue flex items-center">
              <img src="../../../../../assets/dashboard-header-svg/templates.svg" alt="Template Icon" class="m-1" />
              <span class="sm:flex md:hidden xl:flex ">Templates</span></a
            >
          </li>
          <li>
            <a
              href="https://www.forsta.com/facilities/"
              title="Facilities"
              class="px-2 h-max hover:bg-accent-blue flex items-center "
            >
              <img src="../../../../../assets/dashboard-header-svg/facilities.svg" alt="Facility Icon" class="m-1" />
              <span class="sm:flex md:hidden xl:flex">Facilities</span></a
            >
          </li>
          <li>
            <a (click)="logout()" title="Log Out" class="px-2 h-max hover:bg-accent-blue flex items-center">
              <img src="../../../../../assets/dashboard-header-svg/logout.svg" alt="Logout Icon" class="m-1" />
              <span class="sm:flex md:hidden xl:flex">Log Out</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
